import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/lote'

class TipoLoteApiClient {
	async buscaTiposPorProcesso(filtro, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(url)
	}

	async buscaTiposPorNumeroEProcesso(filtro, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/doFornecedor`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(url)
	}
}
export default new TipoLoteApiClient()
